import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getBadgeApiCall = createAsyncThunk("badgeList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: badgeList } = await API.getBadgeApi(submitData);
        //  console.log("*********************************************",letterList);
        dispatch(setLoader(false))
        return badgeList;
    } catch (error) {
        throw error;
    }
});

export const editBadgeApiCall = createAsyncThunk("editBadgeListData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editBadgeData, code, message } = await API.updateBadgeApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editBadgeData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    badgeList: {
        data: [],
        error: null,
    },
    editBadgeData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const BadgeSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBadgeApiCall.fulfilled, (state, action) => {
                state.badgeList.data = action.payload;
            })
            .addCase(getBadgeApiCall.rejected, (state, action) => {
                state.badgeList.error = action.error.message;
            })
            .addCase(editBadgeApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editBadgeData.data = data;
                state.editBadgeData.message = message;
                state.editBadgeData.code = code;
            })
            .addCase(editBadgeApiCall.rejected, (state, action) => {
                state.editBadgeData.error = action.error.message;
            });
    },
});

export default BadgeSlice.reducer;